<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-row class="mx-1">
        <v-col cols="12" class="d-flex justify-end">
            <div class="d-flex align-center flex-wrap">
                <v-btn class="mr-2"
                       :loading="exportingData"
                       icon
                       color="kbPurple"
                       outlined
                       @click="exportAttendees()">
                    <v-icon small>cloud_download</v-icon>
                </v-btn>

                <v-btn color="kbPurple"
                       class="mr-2"
                       :icon="$vuetify.breakpoint.smAndDown"
                       outlined
                       @click="showAttachEventsUi()">
                    <v-icon class="hidden-md-and-up">
                        attachment
                    </v-icon>

                    <span class="hidden-sm-and-down">
                        {{ $t('general.attachInWebSite') }}
                    </span>
                </v-btn>

                <v-btn v-if="!companyBlocked"
                       color="kbPurple"
                       dark
                       @click="createEvent()"
                       :icon="$vuetify.breakpoint.smAndDown">
                    <v-icon class="hidden-md-and-up">add</v-icon>
                    <span class="hidden-sm-and-down">{{ $t('general.createEvent') }}</span>
                </v-btn>

                <v-tooltip bottom v-if="companyBlocked">
                    <template v-slot:activator="{ on }">
                        <div v-on="on">
                            <v-btn disabled
                                   color="kbPurple"
                                   dark
                                   :icon="$vuetify.breakpoint.smAndDown">
                                <v-icon class="hidden-md-and-up">add</v-icon>
                                <span class="hidden-sm-and-down">{{ $t('general.createEvent') }}</span>
                            </v-btn>
                        </div>
                    </template>
                    <span>{{ $t('general.mustChargeBeforeCreateEvents') }}</span>
                </v-tooltip>
            </div>
        </v-col>

        <v-col cols="12" class="text-h6">
            <v-data-table :headers="headers"
                          :items="events"
                          class="elevation-2"
                          :loading="loadingEvents"
                          :options.sync="options"
                          :footer-props="{
                                            'items-per-page-text': `${$t('general.events')} ${$t('general.perPage')}`,
                                            'items-per-page-options': [50, 100, 200]
                                          }"
                          :server-items-length="totalEvents"
                          :must-sort="false">
                <template v-slot:item="{ item }">
                    <tr>
                        <td class="text-center">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-switch class="center-switch"
                                              color="kbDarkBlueText"
                                              @change="togglePublish(item)"
                                              v-model="item.publish"
                                              v-on="on"
                                              :loading="publishingEvent === item._id"
                                              hide-details>
                                    </v-switch>
                                </template>
                                <span>{{item.publish ? $t('general.published') : $t('general.notPublished')}}</span>
                            </v-tooltip>
                        </td>
                        <td class="font-weight-bold">{{ item.title || $t('general.noName') }}</td>
                        <td>{{ item.shortDescription }}</td>
                        <td class="text-center">{{ item.totalSold | formatNumber }}</td>
                        <td class="text-center" v-if="!item.soldOut">
                            {{ item.totalAvailable | formatNumber }}
                        </td>
                        <td v-else class="text-center red--text">
                            {{ $t('general.soldOut') }}
                        </td>
                        <td class="text-center">{{ item.totalTickets | formatNumber }}</td>
                        <td class="px-0 mx-0">
                            <div class="data-table-actions d-flex justify-center align-center">
                                <v-btn icon @click="viewEvent(item)" color="kbDarkBlueText" text>
                                    <v-icon>remove_red_eye</v-icon>
                                </v-btn>
                                <v-menu>
                                  <template v-slot:activator="{ on }">
                                      <v-btn color="kbDarkBlueText" text icon v-on="on">
                                          <v-icon>more_vert</v-icon>
                                      </v-btn>
                                  </template>

                                  <v-list>
                                      <v-list-item @click="showNewEditEvent(item)">
                                          <v-list-item-action>
                                              <v-icon color="kbDarkBlueText">edit</v-icon>
                                          </v-list-item-action>
                                          <v-list-item-title>{{ $t('general.edit') }}</v-list-item-title>
                                      </v-list-item>

                                      <v-list-item @click="showDeleteEvent(item)">
                                          <v-list-item-action>
                                              <v-icon color="kbDarkBlueText">delete</v-icon>
                                          </v-list-item-action>
                                          <v-list-item-title>{{ $t('general.delete') }}</v-list-item-title>
                                      </v-list-item>
                                  </v-list>
                              </v-menu>

                                <v-tooltip left v-if="!item.publish">
                                    <template v-slot:activator="{ on }">
                                        <v-icon v-on="on" color="red" style="cursor: pointer">warning</v-icon>
                                    </template>
                                    <span>{{ $t('general.publishEventToBeShownInSalesLists') }}</span>
                                </v-tooltip>
                            </div>
                        </td>
                    </tr>
                </template>

                <template v-slot:no-data>
                    <v-row>
                        <v-col class="text-center" cols="12" v-if="loadingEvents">
                            {{ $t('general.loadingEvents') }}
                        </v-col>
                        <v-col cols="12" class="red--text text-center" v-else>
                            {{ $t('general.noEventsRegistered') }}
                        </v-col>
                    </v-row>
                </template>
            </v-data-table>
        </v-col>
    </v-row>
</template>

<script>
import { mapState } from 'vuex'
import eventsService from '@/services/eventsService.js'
import notifications from '@/libs/notifications.js'
export default {
  computed: {
    ...mapState({
      loadingEvents: state => state.events.loadingEvents,
      paginationEvents: state => state.events.paginationEvents,
      selectedApp: state => state.apps.selectedApp,
      totalEvents: state => state.events.totalEvents,
      events: state => state.events.events
    }),
    headers () {
      return [
        { text: this.$t('general.status'), align: 'center', value: 'public', sortable: true },
        { text: this.$t('general.name'), value: 'title' },
        { text: this.$t('general.description'), value: 'shortDescription' },
        { text: this.$t('general.soldTickets'), align: 'center', value: 'totalSold' },
        { text: this.$t('general.availableTickets'), align: 'center', value: 'totalAvailable' },
        { text: this.$t('general.totalTickets'), align: 'center', value: 'totalTickets' },
        { text: this.$t('general.actions'), align: 'center', sortable: false, value: '' }
      ]
    }
  },
  data () {
    return {
      options: {
        sortDesc: [true],
        sortBy: ['public']
      },
      publishingEvent: '',
      showDeleteEventDialog: false
    }
  },
  methods: {
    createEvent () {
      this.$emit('createEvent')
    },
    exportAttendees () {
      this.$emit('exportAttendees')
    },
    getEvents () {
      this.$store.commit('SET_PAGINATION_EVENTS', { page: this.options.page, itemsPerPage: this.options.itemsPerPage, sortBy: this.options.sortBy[0], descending: this.options.sortDesc[0] })
      this.$store.dispatch('getEvents')
    },
    viewEvent (event) {
      this.$router.push(`events/${event._id}`)
    },
    showDeleteEvent (event) {
      this.$emit('showDeleteEvent', event)
    },
    showNewEditEvent (event) {
      this.$emit('showNewEditEvent', event)
    },
    showAttachEventsUi () {
      this.$emit('showAttachEventsUi')
    },
    togglePublish (event) {
      this.publishingEvent = event._id
      eventsService.updateEventProperty(
        this.$store.getters.token,
        this.$store.getters.companyUuid,
        this.$store.getters.appUuid,
        event._id,
        { publish: event.publish }
      ).then(() => {
        notifications.success(this.$t('general.eventStateUpdated'))
        this.$store.dispatch('getEvents')
        this.publishingEvent = ''
      }).catch(error => {
        this.event.publish = !this.event.publish
        notifications.error(error.message)
        this.publishingEvent = ''
      })
    }
  },
  props: {
    exportingData: {
      type: Boolean,
      default: false
    },
    companyBlocked: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    options: {
      handler () {
        this.getEvents()
        this.$vuetify.goTo(0)
      },
      deep: true
    }
  }
}
</script>

<style>
    .center-switch .v-input__control {
        margin: auto;
    }
</style>
